import React, {Component} from 'react';
import Translator         from './../../components/Translator';
import Header             from "../Header/Header";
import {connect}          from "react-redux";
import {clearMessage}     from "../../redux/actions";
import packageJson        from "../../../package.json";

class Help extends Component
{
    render()
    {

        let hotlineNumber = <Translator content={"help.number"}/>;

        const localStorageHotline = localStorage.getItem('hotline')
        if (localStorageHotline && localStorageHotline !== '') {
            hotlineNumber = <span>{localStorageHotline}</span>
        }

        if (this.props.showHelp) {
            return (<div className="page page-help">
                <div className="page-inner-wrapper">
                    <Header
                        headerTitle="pageTitles.helppage"
                    />
                    <div className="content-wrapper">
                        <div className="container">
                            <div className="bodytext-app">
                                <Translator content={"help.text"}/>
                            </div>
                            <div className="bodytext-app _hotline">
                                <span className="bigger">
                                    {hotlineNumber}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{
                    position:   'absolute',
                    left:       0,
                    top:        0,
                    opacity:    0.1,
                    userSelect: "none"
                }}>{packageJson.version}</div>
            </div>);
        } else {
            return '';
        }

    }
}


export default connect(state => {
    return {
        showHelp: state.app.showHelp
    }
}, {clearMessage})(Help);
